import React from 'react';
import PageTitle from '../PageTitle';
import PolicyHolderInfo from './PolicyHolderInfo';
import { RoutePaths } from 'Constants/Common';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'state/hooks';
import { useTranslation } from 'react-i18next';

const PersonalDetailsPage = (): JSX.Element => {
    const customer = useAppSelector((state) => state.customer); // consider more performant hook usage
    const { t } = useTranslation();
    if (!customer) return <></>;

    const navigate = useNavigate();

    const onBackButtonClick = () => {
        navigate(RoutePaths.Home);
    };
    return (
        <>
            <div className='card page-content'>
                <PageTitle title={t('personal_details')} />
                <div className='card-body page-content-body'>
                    <PolicyHolderInfo />
                </div>
            </div>
            <div className='bottom-navigation'>
                <button
                    aria-label='back-button'
                    className='btn btn-secondary progress-button'
                    onClick={() => onBackButtonClick()}>
                    {t('back')}
                </button>
            </div>
        </>
    );
};

export default PersonalDetailsPage;
